<template>
  <v-container fluid grid-list-md :style="{ maxWidth: '1200px' }">
    <v-layout row wrap>
      <v-flex sm12 md4>
        <v-card class="mb-2">
          <v-card-title primary-title>
            <h1 class="headline">Enable gracefull shutdown mode</h1>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex>
                <p>Enable the gracefull shutdown mode?</p>
                <v-switch
                  :input-value="settings.stop_tradeengines || false"
                  @change="setGracefulShutdownMode($event)"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex sm12 md8>
        <CharityList></CharityList>
        <v-flex>
          <v-card>
            <v-card-title primary-title>
              <v-layout row>
                <v-flex grow pa-1>
                  <h1 class="headline">Partners</h1>
                </v-flex>
                <v-flex shrink pa-1>
                  <v-btn dark color="primary" @click="toggleAddNewPartner">
                    {{ btnAddNewPartnerTitle }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
            <AddPartner v-if="showAddNewPartner"></AddPartner>
            <v-card-text v-else>
              <template>
                <div>
                  <v-text-field
                    v-model="partnerSearch"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-data-table
                    :items="partners || []"
                    :headers="partnersTableHeaders"
                    :expand="expand"
                    item-key="id"
                    :search="partnerSearch"
                  >
                    <template v-slot:items="props">
                      <tr @click="props.expanded = !props.expanded">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.created_at | formatDate }}</td>
                        <td>{{ props.item.ref_share_pct }}</td>
                      </tr>
                    </template>
                    <template v-slot:expand="props">
                      <v-card v-if="!isHidden" flat>
                        <v-card-text>
                          Partner ID: {{ props.item.id }}
                        </v-card-text>
                        <v-card-text>
                          GSMG user ID: {{ props.item.gsmg_user_id }}
                        </v-card-text>
                        <v-card-text>
                          ETH address: {{ props.item.eth_addr_hex }}
                        </v-card-text>
                        <v-card-text>
                          BNB address: {{ props.item.bnb_addr_hex }}
                        </v-card-text>
                        <v-card-text>
                          Referral url:<br />
                          {{ base_url }}/register?invite={{ props.item.token }}
                        </v-card-text>
                        <v-btn dark color="primary" @click="isHidden = true">
                          Edit
                        </v-btn>
                      </v-card>
                      <v-card v-else flat>
                        <form ref="form">
                          <v-flex sm12>
                            <v-text-field
                              label="Name"
                              :value="props.item.name"
                              name="name"
                            ></v-text-field>
                          </v-flex>
                          <v-flex sm12>
                            <v-text-field
                              label="GSMG user ID"
                              :value="props.item.gsmg_user_id"
                              name="gsmg_user_id"
                            ></v-text-field>
                          </v-flex>
                          <v-flex sm12>
                            <v-text-field
                              label="ETH address"
                              :value="props.item.eth_addr_hex"
                              name="eth_addr_hex"
                            ></v-text-field>
                          </v-flex>
                          <v-flex sm12>
                            <v-text-field
                              label="BNB address"
                              :value="props.item.bnb_addr_hex"
                              name="bnb_addr_hex"
                            ></v-text-field>
                          </v-flex>
                          <v-flex sm12>
                            <v-text-field
                              label="Revenue share (%)"
                              :value="props.item.ref_share_pct"
                              name="ref_share_pct"
                            ></v-text-field>
                          </v-flex>
                          <v-btn
                            dark
                            color="primary"
                            @click="editPartner(props.item.id)"
                          >
                            Save
                          </v-btn>
                          <v-btn dark color="primary" @click="isHidden = false">
                            Cancel
                          </v-btn>
                        </form>
                      </v-card>
                    </template>
                  </v-data-table>
                </div>
              </template>
            </v-card-text>
          </v-card>
        </v-flex>
        <PartnerPayments></PartnerPayments>
        <v-flex>
          <v-card>
            <v-card-title primary-title>
              <h1 class="headline">Users</h1>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="userSearch"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :items="users || []"
                :headers="userTableHeaders"
                :search="userSearch"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.email }}</td>
                  <td>{{ props.item.created_at }}</td>
                  <td>
                    <v-switch
                      :input-value="props.item.activated"
                      @change="toggleUserActivation($event, props.item)"
                    ></v-switch>
                  </td>
                  <td>
                    <v-switch
                      v-if="props.item.front_end_settings"
                      :input-value="
                        props.item.front_end_settings.trade_engine_on
                      "
                      @change="toggleUserEngine($event, props.item)"
                    ></v-switch>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import PartnerPayments from "../components/admin/PartnerPayments";
import CharityList from "../components/admin/CharityList";
import { mapGetters } from "vuex";
import AddPartner from "../components/admin/AddPartner";

export default {
  components: {
    PartnerPayments,
    CharityList,
    AddPartner
  },
  data: function() {
    return {
      base_url: window.location.origin,
      isHidden: false,
      invites_count: 1,
      invites_name: "",
      invites_eth_addr: "",
      invites_errors: null,
      users: null,
      partners: null,
      settings: {},
      userTableHeaders: [
        {
          text: "ID",
          value: "id"
        },
        {
          text: "E-Mail",
          value: "email"
        },
        {
          text: "Registered at",
          value: "created_at"
        },
        {
          text: "Activated",
          value: "activated"
        },
        {
          text: "Engine status",
          value: "front_end_settings.trade_engine_on"
        }
      ],
      userSearch: "",
      partnerSearch: "",
      expand: false,
      partnersTableHeaders: [
        { text: "Name", value: "name" },
        {
          text: `First added (${moment()
            .tz(moment.tz.guess())
            .format("z")})`,
          value: "created_at"
        },
        { text: "Revenue share (%)", value: "ref_share_pct" }
      ],
      btnAddNewPartnerTitle: "Add partner",
      showAddNewPartner: false
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    })
  },
  mounted: async function() {
    axios.get("/api/v1/admin/users").then(res => {
      this.users = res.data;
    });

    axios.get("/api/v1/admin/partners").then(res => {
      this.partners = res.data;
    });

    axios.get("/api/v1/admin/settings").then(res => {
      this.settings = res.data || {};
    });
  },

  methods: {
    toggleAddNewPartner: function() {
      this.showAddNewPartner = !this.showAddNewPartner;
      this.btnAddNewPartnerTitle = this.showAddNewPartner
        ? "Cancel"
        : "Add partner";
    },
    toggleUserEngine: async function(e, user) {
      try {
        const { data } = await axios.post(
          "/api/v1/admin/toggleUserEngine/" + user.id
        );
        user.activated = data.activated;
        user.front_end_settings.trade_engine_on =
          data.front_end_settings.trade_engine_on;
      } catch (error) {
        await swal({
          title: "User is unable to trade",
          text:
            "This use is unable to trade at this moment (no / wrong api keys?)",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark
            ? "swal-type-error-dark"
            : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        return false;
      }
    },
    toggleUserActivation: async function(e, user) {
      try {
        const { data } = await axios.post(
          "/api/v1/admin/toggleUserActivation/" + user.id
        );
        user.activated = data.activated;
        user.front_end_settings.trade_engine_on =
          data.front_end_settings.trade_engine_on;
      } catch (error) {
        await swal({
          title: "Unable to activate user",
          text: "This shouldn't happen",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark
            ? "swal-type-error-dark"
            : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        return false;
      }
    },
    setGracefulShutdownMode: async function(e) {
      // confirm
      let confirmation = await swal({
        title: "Warning",
        text: "This will " + (e ? "halt" : "start") + " all trading. ",
        showCancelButton: true,
        showCloseButton: true,
        customClass: "swal-type-warning",
        imageUrl: "/img/popup_img_warning.png",
        imageHeight: 48,
        imageWidth: 48
      });

      if (confirmation.dismiss) {
        return false;
      }

      try {
        const mode = e === true ? 1 : 0;

        await axios.post("/api/v1/admin/setgracefulshutdownmode/" + mode);

        this.settings.stop_tradeengines = e;
      } catch (e) {
        console.log(e);
      }
    },
    editPartner: async function(partnerId) {
      const { data } = await axios.post(
        "/api/v1/admin/updatePartner/" + partnerId,
        {
          name: this.$refs.form.name.value,
          gsmg_user_id: this.$refs.form.gsmg_user_id.value,
          eth_addr_hex: this.$refs.form.eth_addr_hex.value,
          bnb_addr_hex: this.$refs.form.bnb_addr_hex.value,
          ref_share_pct: this.$refs.form.ref_share_pct.value
        }
      );

      this.partners.forEach(function(element) {
        if (element.id == data.id) {
          element.name = data.name;
          element.gsmg_user_id = data.gsmg_user_id;
          element.eth_addr_hex = data.eth_addr_hex;
          element.bnb_addr_hex = data.bnb_addr_hex;
          element.ref_share_pct = data.ref_share_pct;
        }
      });

      this.isHidden = false;

      await swal({
        title: "Partner updated",
        text: "Partner updated successfully",
        showCloseButton: true,
        imageUrl: "/img/popup_img_success.png",
        imageHeight: 80,
        imageWidth: 80,
        customClass: this.themeDark
          ? "swal-type-success-dark"
          : "swal-type-success"
      });
    },
    clicked(value) {
      this.expanded.push(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/admin.vue